import { generarId } from "./crud";


export const TIPOS_PERMISO = ["TEMPORAL", "LIMITADO", "PERMANENTE"];

export const TIPOS_DOCUMENTO = [
  "CÉDULA DE CIUDADANIA",
  "TARJETA DE IDENTIDAD",
  "REGISTRO CIVIL",
  "NIT",
  "DNI",
  "PASAPORTE",
  "CÉDULA DE EXTRANJERIA",
];

export const TIPOS_VISITANTE = ["VISITANTE", "HUESPED"];
export const TIPOS_VEHICULO = ["CARRO", "MOTO"];

export const ESTADOS = ["Pendiente", "Ingreso", "Salida"];
export const TIPOS_INGRESO = ["Peatonal", "Vehiculo", "Taxi", "Bicicleta"];

export const ROLES_PORTERIA = ["GUARDA", "ADMINISTRADOR", "SUPER"];

export const VIVIENDAS_PRECARGADAS = [
  "ADICIONAR MANUALMENTE",
  "ADMINISTRACIÓN",
  "COPROPIEDAD",
  "PORTERIA",
];

export const NIT_COORDINAR = "900362633";

export const CARGOS_COORDINAR = [
  "ANALISTA COMERCIAL",
  "ANALISTA DE CARTERA",
  "ANALISTA DE NOMINA",
  "COORDINADOR DE DESARROLLO",
  "AUXILIAR DE SISTEMAS",
  "ASESOR TECNOLOGÍA",
  "AUXILIAR ADMINISTRATIVA",
  "AUXILIAR DE CONSULTORÍA",
  "AUXILIAR DE CONTRATACIÓN",
  "AUXILIAR DE GESTIÓN HUMANA",
  "AUXILIAR DE SERVICIOS",
  "AUXILIAR SIG",
  "COORDINADOR CONTABLE",
  "COORDINADOR GH",
  "COORDINADOR SGSST",
  "COORDINADORA ADMINISTRATIVA",
  "COORDINADORA GH",
  "DIRECTOR DE SERVICIOS",
  "DIRECTOR DE TECNOLOGÍA",
  "DIRECTORA COMERCIAL",
  "DIRECTORA DE SERVICIOS",
  "DIRECTORA FINANCIERA Y ADMIN",
  "DIRECTORA GESTIÓN HUMANA",
  "DIRECTORA SIG",
  "EJECUTIVO CUENTA 1",
  "EJECUTIVO CUENTA 2",
  "EJECUTIVO CUENTA 3",
  "EJECUTIVO CUENTA 4",
  "EJECUTIVO CUENTA 5",
  "GERENCIA",
  "JEFE DE SEGURIDAD",
  "KEY ACCOUNT MANAGER",
  "OPERADOR DE MEDIOS TECNOLÓGICOS",
  "PRACTICANTE ADMIN",
  "PROGRAMADOR",
  "SUPERVISOR TÉCNICO",
  "TÉCNICO DE MEDIOS TECNOLÓGICOS",
];

export const opcionesVivienda = (nit = localStorage.getItem("CodigoCliente")) =>
  nit === NIT_COORDINAR
    ? [VIVIENDAS_PRECARGADAS[0], ...CARGOS_COORDINAR, ...VIVIENDAS_PRECARGADAS.slice(1)]
    : [...VIVIENDAS_PRECARGADAS];

export const esPorteria = (permisos = localStorage.getItem("Permisos")) =>
  ROLES_PORTERIA.includes(permisos);

export const fechaHoraDart = (fecha = new Date()) => {
  const p = (n, len = 2) => String(n).padStart(len, "0");
  return (
    `${fecha.getFullYear()}-${p(fecha.getMonth() + 1)}-${p(fecha.getDate())} ` +
    `${p(fecha.getHours())}:${p(fecha.getMinutes())}:${p(fecha.getSeconds())}.` +
    `${p(fecha.getMilliseconds(), 3)}000`
  );
};

export const fechaDart = (fecha = new Date()) => fechaHoraDart(fecha).substring(0, 10);

export const horaDart = (fecha = new Date()) => {
  const h = fecha.getHours();
  const minutos = String(fecha.getMinutes()).padStart(2, "0");
  return `${h % 12 || 12}:${minutos} ${h >= 12 ? "PM" : "AM"}`;
};

export const fechaHora12Dart = (fecha = new Date()) => {
  const h = fecha.getHours();
  const h12 = String(h % 12 || 12).padStart(2, "0");
  const minutos = String(fecha.getMinutes()).padStart(2, "0");
  return `${fechaDart(fecha)} ${h12}:${minutos} ${h >= 12 ? "PM" : "AM"}`;
};

export const parsearFechaPase = (texto) => {
  if (!texto) return null;
  const valor = `${texto}`.trim();

  const dart = valor.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?$/
  );
  if (dart) {
    const [, a, m, d, h, mi, s, ms] = dart;
    return new Date(
      Number(a),
      Number(m) - 1,
      Number(d),
      Number(h),
      Number(mi),
      Number(s || 0),
      Number((ms || "0").padEnd(3, "0").substring(0, 3))
    );
  }

  const fecha = new Date(valor);
  return isNaN(fecha) ? null : fecha;
};


// Fecha como se muestra en los listados: "2026-10-07 09:38 AM". Si no se entiende, se deja igual.
export const formatearFechaListado = (valor) => {
  if (!valor) return "";
  const fecha = parsearFechaPase(valor);
  return fecha ? fechaHora12Dart(fecha) : valor;
};

// Historial de ingresos y salidas: la app y la web lo guardan solo para pases PERMANENTE y LIMITADO
// (detalle_pase.dart → agregarHistoricoAPases). Cada movimiento trae estado, autorizo y fechaHora.
export const TIPOS_CON_HISTORIAL = ["PERMANENTE", "LIMITADO"];

export const rutaHistoricoPase = (nit, tipoPermiso, id) => `coordi_ph/${nit}/historico/${tipoPermiso}/${id}`;

// El nit sale de la ruta donde se leyó el pase, porque un usuario SUPER ve pases de varios conjuntos.
export const nitDePase = (pase) =>
  (pase.rutaRegistro || "").match(/coordi_ph\/([^/]+)/)?.[1] || localStorage.getItem("CodigoCliente") || "";

// Movimientos del historial, del más reciente al más antiguo. Algunos registros viejos solo traen
// fechaHoraIngreso/autorizaIngreso o fechaHoraSalida/autorizaSalida.
export const movimientosHistorial = (historial) =>
  Object.values(historial || {}).map(h => {
    const texto = h.fechaHora || h.fechaHoraIngreso || h.fechaHoraSalida || "";
    return {
      fecha: parsearFechaPase(texto),
      fechaTexto: formatearFechaListado(texto) || "Sin fecha",
      estado: h.estado || "Sin estado",
      autorizo: h.autorizo || h.autorizaIngreso || h.autorizaSalida || "Sin registrar",
    };
  }).sort((a, b) => (b.fecha?.getTime() ?? 0) - (a.fecha?.getTime() ?? 0));

export const rutaColeccionPases = (nit, tipoPermiso, year, mes) =>
  tipoPermiso === "TEMPORAL" || tipoPermiso === "LIMITADO"
    ? `coordi_ph/${nit}/visitantes/${tipoPermiso}/${year}/${mes}`
    : `coordi_ph/${nit}/visitantes/${tipoPermiso}`;

export const rutaPase = (nit, tipoPermiso, year, mes, id) =>
  `${rutaColeccionPases(nit, tipoPermiso, year, mes)}/${id}`;

export const obtenerYearMes = (pase) => {
  let fecha;
  switch (pase?.tipoPermiso) {
    case "TEMPORAL":
      fecha = pase.fechaTemporalPermiso;
      break;
    case "LIMITADO":
      fecha = pase.fechaInicioPermiso;
      break;
    case "PERMANENTE":
      return ["", ""];
    default:
      return ["", ""];
  }
  if (fecha && `${fecha}`.includes("-")) {
    const partes = `${fecha}`.split("-");
    return [partes[0], partes[1]];
  }
  return ["", ""];
};

export const viviendaComoClave = (direccion) =>
  (direccion || "").toString().toLowerCase().replaceAll(" ", "");

export const limpiarDireccion = (direccion) =>
  (direccion || "").toString().toLowerCase().replace(/[\s\-.#\n]/g, "");


export const nuevoPaseVisitante = (campos = {}) => ({
  usuario: null,
  fechaCreacionRegistro: null,
  casa: null,
  tipoPermiso: null,
  fechaInicioPermiso: null,
  fechaFinalPermiso: null,
  fechaTemporalPermiso: null,
  id: null,
  nombreDocumentoVisitante: null,
  tipoDocumentoVisitante: null,
  numeroDocumentoVisitante: null,
  contador: null,
  marcaVehiculo: null,
  tipoVehiculo: null,
  placasVehiculo: null,
  colorVehiculo: null,
  existeVehiculo: null,
  nombreCliente: null,
  codigoCliente: null,
  estado: null,
  fechaHoraIngreso: null,
  fechaHoraSalida: null,
  autorizaIngreso: null,
  autorizaSalida: null,
  horaTemporalPermiso: null,
  horaSalidaPermiso: null,
  correoElectronico: null,
  eps: "",
  arl: "",
  dispositivo: "",
  marca: "",
  serial: "",
  tipoIngreso: "",
  correoNotificacion: "",
  tipoVisitante: null,
  esMenor: null,
  urlPermiso: null,
  idReserva: null,
  telefonoFactura: null,
  fechaNotificacionFactura: null,
  ...campos,
});

// Pase creado desde la web (a mano o desde Excel): valores fijos iguales en los dos casos.
export const nuevoPaseWeb = (campos = {}) => nuevoPaseVisitante({
  nombreCliente: localStorage.getItem("RazonSocial") || "",
  codigoCliente: localStorage.getItem("CodigoCliente") || "",
  correoNotificacion: localStorage.getItem("CorreoElectronico") || "",
  tipoPermiso: "TEMPORAL",
  tipoVisitante: "VISITANTE",
  esMenor: "false",
  urlPermiso: null,
  colorVehiculo: "...",
  marcaVehiculo: "",
  correoElectronico: "",
  fechaInicioPermiso: "",
  fechaFinalPermiso: "",
  horaSalidaPermiso: "11:59 PM",
  ...campos,
});

// Rutas de Firebase para guardar un pase nuevo y su índice por vivienda (pases_usuarios).
export const cambiosNuevoPase = (nit, pase) => {
  const [year, mes] = obtenerYearMes(pase);
  const ruta = rutaColeccionPases(nit, pase.tipoPermiso, year, mes);
  const id = generarId(ruta);
  const indice = `pases_usuarios/${nit}/${viviendaComoClave(pase.casa)}`;
  return {
    [`${ruta}/${id}`]: pase,
    [`${indice}/${generarId(indice)}`]: { ruta: `${ruta}/${id}` },
  };
};

export const construirDireccion = (tipoVivienda, sector, numero) => {
  const s = (sector || "").trim();
  const n = (numero || "").trim();
  if (tipoVivienda === "APARTAMENTO") return `TORRE ${s} APARTAMENTO ${n}`;
  return s ? `MANZANA ${s} CASA ${n}` : `CASA ${n}`;
};

export const extraerNumero = (texto, palabra) => {
  if (!texto) return "";
  const match = `${texto}`.match(new RegExp(`${palabra}\\s+(\\S+)`, "i"));
  return match ? match[1] : "";
};

// Mismas reglas que detalle_pase.dart (_gestionarVisitante y _esPermisoVigente). Devuelve el
// mensaje que impide gestionar el pase, o null si se puede.
export const motivoNoGestionable = (pase, hoy = fechaDart()) => {
  if (pase.estado === "Salida" && pase.tipoPermiso === "TEMPORAL") {
    return "El pase ya fue cerrado. Por lo cual la edición de su estado está bloqueada.";
  }
  const esFecha = (f) => /^\d{4}-\d{2}-\d{2}/.test(f || "");
  if (pase.tipoPermiso === "TEMPORAL" && esFecha(pase.fechaTemporalPermiso)
      && pase.fechaTemporalPermiso.substring(0, 10) > hoy) {
    return `El pase aún no está disponible. Fecha de inicio: ${pase.fechaTemporalPermiso}`;
  }
  if (pase.tipoPermiso === "LIMITADO" && esFecha(pase.fechaFinalPermiso)
      && hoy > pase.fechaFinalPermiso.substring(0, 10) && pase.estado === "Pendiente") {
    return `El pase está vencido. Fecha final: ${pase.fechaFinalPermiso}`;
  }
  return null;
};
